<template>
<div class="projects" :key="componentKey">
  <el-dialog
    :show-close="false"
    :visible.sync="deleteProjectsModal"
    width="788px">
    <template slot="title">
      <div class="modal-title acr-bold-22">
        <div>
          <div class="modal-btn" @click="deleteProjectsModal = false">
            <svgicon name="Chevron-left"></svgicon>
          </div>
          <span style="margin-top: -1px">Are you sure you want to delete selected project(s)?</span>
        </div>
        <div class="modal-btn active" @click="deleteSelected">
          <svgicon name="Arrow-right"></svgicon>
        </div>
      </div>
    </template>
    <div class="projects-table" v-if="selectedProjects" style="padding: 0;min-height: unset">
      <div class="projects-table-item np" v-for="item in selectedProjects" :key="item.id">
        <div class="projects-table-item__name">
          <svgicon name="Bar-chart" class="projects-table-item__icon" v-if="item.project_type === 'brand_detection'"></svgicon>
          <svgicon name="Cut2" class="projects-table-item__icon" v-else></svgicon>
          <span class="acr-bold">{{item.project_name}}</span>
        </div>
        <div class="projects-info"></div>
      </div>
    </div>
  </el-dialog>
  <BaseLoader v-if="loading" />
  <div class="projects-table" :class="{'min': showFilter}" v-if="!loading">
    <div class="table-header">
      <el-button
        class="add-project"
        type="text"
        @click="$router.push({ name: 'dashboard', params: { creatingProject: true } })">
        <svgicon name="Plus" />
        Add project
      </el-button>
      <div class="header-aside">
        <progress-model />
        <models-history />
      </div>
    </div>
    <div class="projects-table-item">
      <div class="projects-info acr-bold-16" style="padding-left: 54px;">Name of project</div>
      <div class="projects-info acr-bold-16" v-if="selectedProjects.length === 0">
        <div class="projects-title">Status</div>
        <div class="projects-title">Created</div>
        <div class="projects-title">Modified</div>
      </div>
      <div class="projects-option" v-else>
        <div class="projects-option__selected acr-bold">Selected: {{selectedProjects.length}}</div>
        <div class="projects-btn projects-btn--default acr-bold sm" style="margin-right: 5px;" @click="deleteProjectsModal = true">
          Delete
        </div>
        <div class="projects-btn projects-btn--transparent" @click="resetSelected">
          <svgicon name="Close"></svgicon>
        </div>

      </div>
      <el-button
        class="filters-btn"
        type="text"
        @click="showFilter = !showFilter">
        <svgicon :name="showFilter ? 'FilterOpen' : 'FilterClose'" />
      </el-button>
    </div>
    <div class="content-wrapper" style="min-height: calc(100vh - 195px)">
      <div class="projects-table-item" v-for="item in projects" :key="item.id" :class="{'in-progress': item.status !== 100}">
        <el-checkbox @change="handleSelection($event, item)"/>
        <div class="projects-table-item__name" @click="handleRowClick(item)">
          <svgicon name="Bar-chart" class="projects-table-item__icon" v-if="item.project_type === 'brand_detection'"></svgicon>
          <svgicon name="Cut2" class="projects-table-item__icon" v-else></svgicon>
          <span class="acr-bold">{{item.project_name}}</span>
        </div>
        <div class="projects-info acr-medium" @click="handleRowClick(item)">
          <div class="projects-title acr-medium" v-if="item.error_during_processing">
            <span>Terminated</span>
            <div class="projects-status projects-status--grey" @click="handleRerun('rerun', item)">
              <svgicon name="Pause2"></svgicon>
            </div>
              <!--<svgicon name="pause_circle_fill" class="projects-status projects-status&#45;&#45;grey"></svgicon>-->
          <!--<span>-->
            <!--{{item.error_msg ? item.error_msg : 'Error'}}-->
          <!--</span>-->
          </div>
          <div class="projects-title acr-medium" v-if="item.status === 100 && !item.error_during_processing">
          <span style="width: 73px;text-align: right">
            <span v-if="!item.is_archived">Completed</span>

            <span v-else>
                <span>Archived</span>
            </span>
          </span>
            <el-tooltip class="item"  effect="light" placement="top" popper-class="frame-tooltip" v-if="item.is_archived">
              <div slot="content">
                <div style="max-width: 175px;text-align: center" class="restore-tooltip">
                  <div class="acr-bold restore-tooltip__title">Project is in archive</div>
                  <div class="acr-regular restore-tooltip__subtitle">To reduce resource consumption, the project was archived</div>
                  <div class="restore-tooltip__btn" @click="handleRerun('rerun', item)">
                    <span style="margin-top: -2px">Restore</span>
                  </div>
                </div>
              </div>
              <div class="projects-status projects-status--arch" :class="{'projects-status--grey': item.is_archived}" @click="handleRowClick(item)">
                <svgicon name="Archive2"></svgicon>
              </div>
            </el-tooltip>
            <div class="projects-status" :class="{'projects-status--grey': item.is_archived}" @click="handleRowClick(item)" v-else>
              <svgicon name="Done"></svgicon>
            </div>
          </div>
          <div class="projects-title acr-medium" v-if="item.status !== 100 && !item.error_during_processing" @click="handleRowClick(item)">
          <span>
            Processing
          </span>
            <div class="pie-chart" :style="{'background': `${piePercent(item.status)}`}"></div>
          </div>
          <div class="projects-title acr-medium" @click="handleRowClick(item)">{{new Date(item.created_at).toLocaleDateString("en-US", { year: 'numeric', month: 'short', day: 'numeric' })}}</div>
          <div class="projects-title acr-medium" @click="handleRowClick(item)">{{new Date(item.updated_at).toLocaleDateString("en-US", { year: 'numeric', month: 'short', day: 'numeric' })}}</div>
        </div>
        <span style="transform: translateX(5px)">
        <el-dropdown trigger="hover" @command="handleRerun($event, item)">
        <div class="projects-btn projects-btn--transparent">
          <svgicon name="More"></svgicon>
        </div>
        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item command="rerun" v-if="item.status === 100 || item.error_during_processing">Re-run</el-dropdown-item>
          <el-dropdown-item command="duplicate" v-if="item.status === 100 || item.error_during_processing">Duplicate and Re-run</el-dropdown-item>
          <el-dropdown-item command="terminate" v-if="item.status !== 100">Terminate processing</el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
      </span>

      </div>
    </div>
      <SmallFooter :no-border="false"></SmallFooter>
  </div>
  <BaseFilter :show-filter="showFilter" :show-sorting="true" @sort="sorting = $event" :one-column="true" @close="showFilter = false" :key="rerenderFilters">
    <div v-for="(filter, index) in filters" :key="index">
      <div class="filter__subtitle acr-medium-18" v-if="filter.item_label">{{filter.item_label}}</div>
      <div v-if="filter.filter_values" style="display: flex;flex-direction: column">
          <el-checkbox v-for="v in filter.filter_values" :key="v" @change="onFilterSelect($event, filter.filter_var, v)"><span class="acr-medium">{{v}}</span></el-checkbox>
      </div>
    </div>
    <div class="filter-btn acr-bold" slot="clear" v-if="filterApplied" @click="clearFilters">Clean</div>
  </BaseFilter>
  <el-dialog
    :title="rerun.title"
    :visible.sync="rerun.openModal"
    width="450px">
    <form id="rerun" @submit.prevent="rerun.submit">
      <div class="modal-field">
        <div class="modal-field__label acr-bold-18">Select model type</div>
        <model-type-select v-model="rerun.modelType" />
      </div>
    </form>
    <template slot="footer">
      <el-button @click="rerun.openModal = false">Cancel</el-button>
      <el-button
        form="rerun"
        native-type="submit"
        type="primary"
        :disabled="!rerun.modelType"
        :loading="rerun.loading">
        Submit
      </el-button>
    </template>
  </el-dialog>
</div>
</template>

<script>
import { mapActions } from 'vuex';
import { getProjects, deleteProject, rerunProject, fetchSuggestionInProjects, getAllProjectFilters, cancelProjectProcessing } from '../../api/projects';
import BaseFilter from '../../components/BaseFilter';
import BaseLoader from '../../components/BaseLoader';
import ModelsHistory from './componenets/ModelsHistory';
import ModelTypeSelect from '../../components/ModelTypeSelect';
import ProgressModel from './componenets/ProgressModel';
import SmallFooter from '../../components/footer/SmallFooter';

const defaultRerunOptions = {
  duplicate: false,
  loading: false,
  modelType: '',
  openModal: false,
  projectId: null,
  title: '',
  submit: () => null,
};

export default {
  name: "Projects",
  components: {
    BaseFilter,
    ModelsHistory,
    ModelTypeSelect,
    ProgressModel,
    SmallFooter,
    BaseLoader
  },
  data() {
    return {
      rerun: defaultRerunOptions,
      showFilter: true,
      checked: false,
      projects: [],
      filters: [],
      filteredProjects: [],
      projectsSelectionActive: false,
      deleteProjectsModal: false,
      selectedProjects: [],
      selectedFilters: [],
      componentKey: 0,
      rerenderFilters: 0,
      sorting: 'desc',
      loading: true
    }
  },
  watch: {
    selectedFilters() {
      const query = {};
      this.transformedFilters.forEach((item) => {
        query[Object.keys(item)[0].toLowerCase()] = item[Object.keys(item)[0]];
      });

      getProjects(query, this.sorting).then(res => this.projects = res.data.projects);
    },
    sorting() {
      const query = {};
      this.transformedFilters.forEach((item) => {
        query[Object.keys(item)[0].toLowerCase()] = item[Object.keys(item)[0]];
      });

      getProjects(query, this.sorting).then(res => this.projects = res.data.projects);
    },
  },
  computed: {
    transformedFilters() {
      const arrayOfFilters = Object.keys(this.selectedFilters).map((item) => {
        return {[item]: Object.keys(this.selectedFilters[item]).filter((x) => !!this.selectedFilters[item][x]).join()};
      });

      return arrayOfFilters
    },
    filterApplied() {
      return this.transformedFilters.filter((i) => !!i[Object.keys(i)[0]]).length
    },
  },
  created() {
    this.loading = true;
    getProjects().then(res => {
      this.projects = res.data.projects;
    });
    getAllProjectFilters().then(res => {
      this.filters = res.data.left_filters;
      this.loading = false;
    });
  },
  mounted() {
    this.$socket.on('project-status-update', (e, data) => {
      this.projects = this.projects.map((i) => {
        if (i.id === data.id) {
          return {...i, status: data.status}
        } return i
      })
    })
  },
  methods: {
    ...mapActions({
      success: 'success',
    }),
    clearFilters() {
      this.selectedFilters = [];
      this.rerenderFilters += 1;
    },
    resetSelected() {
      this.componentKey += 1;
      this.selectedProjects = [];
    },
    handleRowClick(item) {
      if (item.status !== 100) return
      if (item.project_type === 'video_analytics') {
        this.$router.push({ name: 'video-cutting', params: { projectId: item.id }})
      } else {
        this.$router.push({ name: 'project', params: { projectId: item.id }})
      }
    },
    fetchAutocomplete(str, cb) {
      fetchSuggestionInProjects(str).then((res) => {
        cb(res.data.suggestions)
      });
    },
    handleSelectSuggestion(item) {
      this.search = item;
    },
    updateStatuses() {
      getProjects().then(data => this.projects = data.data.projects);
    },
    handleDelete(projectId) {
      if (this.projects.find((project) => projectId === project.id)) {
        deleteProject(projectId).then(() => {
          this.projects = this.projects.filter((project) => project.id !== projectId);
        });
      }
    },
    handleRerun(command, { id: projectId, project_type } ) {
      if (command === 'terminate') {
        let formD = new FormData();
        formD.append('project_id', projectId);

        cancelProjectProcessing(formD).then(() => {
          this.updateStatuses();
        });
        return;
      }

      const isDuplicate = command === 'duplicate';
      if (project_type === 'brand_detection') {
        this.rerun = {
          ...this.rerun,
          duplicate: isDuplicate,
          openModal: true,
          projectId: projectId,
          title: isDuplicate ? 'Duplicate and Re-run project' : 'Re-run project',
          submit: isDuplicate ? this.submitDuplicate : this.submitRerun,
        };
      } else {
        rerunProject(projectId, isDuplicate ? { duplicate: true } : {}).then(() => {
          this.updateStatuses();
        });
      }
    },
    async submitRerun(_, otherParams = {}) {
      try {
        this.rerun.loading = true;
        const { modelType: model_type, projectId } = this.rerun;
        const params = { ...otherParams, model_type };
        const { data = {} } = await rerunProject(projectId, params);
        this.success(data.msg);
        this.updateStatuses();
      } finally {
        this.rerun = defaultRerunOptions;
      }
    },
    submitDuplicate() {
      this.submitRerun(null, { duplicate: true });
    },
    deleteSelected() {
      this.selectedProjects.forEach((project) => this.handleDelete(project.id));
      this.deleteProjectsModal = false;
      this.resetSelected();
    },
    handleSelection(value, project) {
      if (value) {
        this.selectedProjects.push(project)
      } else {
        this.selectedProjects = this.selectedProjects.filter((item) => item.id !== project.id)
      }
    },
    onFilterSelect(value, filter, field) {
      const v = typeof value === 'object' ? value.target.checked : value;
      this.selectedFilters = {
        ...this.selectedFilters,
        [filter]: {
          ...this.selectedFilters[filter],
          [field]: v
        },
      };
    },
    piePercent(percent) {
      return `radial-gradient(
        circle closest-side,
        transparent 66%,
        white 0
    ),
    conic-gradient(
        #9BC225 0,
        #9BC225 ${percent}%,
        rgba(0,0,0,.1) 0,
        rgba(0,0,0,.1) 100%
    )`
    },
  },
}
</script>

<style scoped lang="scss">
  /deep/
  .projects-table {
    .el-checkbox {
      &.is-checked {
        .el-checkbox__inner {
          width: 30px;
          height: 30px;
          display: flex;
          align-items: center;
          justify-content: center;
          &::after {
            width: 14px;
            height: 11px;
            content: url("../../assets/svg/Done.svg");
            transform: scale(1) translate(-50%, -50%);
            border: none;
            left: 50%;
            top: 50%;
          }
        }
      }
      &__inner {
        width: 30px;
        height: 30px;
        border: none;
        background: #F2F4F6;
        &::after {
          width: 14px;
          height: 11px;
          content: url("../../assets/svg/Done.svg");
          transform: scale(0);
          transition: all .3s ease;
          border: none;
        }
      }
    }
  }


  /deep/
  .el-popper {
    display: none !important;
    &::after {
      opacity: 0;
    }
  }

  /deep/
  .el-dropdown-menu {
    box-shadow: 0px 0px 8px rgba(0, 16, 48, 0.25);
    border-radius: 8px;
  }

  .table-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    min-height: 60px;
    padding: 0 20px;
    background: var(--grey);
    border-bottom: 1px solid var(--border-color);
  }

  .add-project {
    font-size: 18px;
    color: var(--primary);
    font-weight: 700;
    transition: 0.3s;

    /deep/ {
      span {
        display: flex;
        align-items: center;
        gap: 23px;
      }

      svg {
        width: 34px;
        height: 34px;
        padding: 10px;
        background: var(--green);
        color: white;
        border-radius: 3px;
        transition: 0.3s;
      }
    }

    &:hover {
      svg {
        background-color: var(--green-active);
      }
    }
  }

  .header-aside {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    align-self: stretch;
    gap: 18px;
    max-width: 425px;
    width: 100%;
  }

  .filters-btn {
    svg {
      width: 30px;
      height: 20px;
      color: var(--primary);
      transition: 0.3s;
    }
    &:hover {
      svg {
        color: inherit;
      }
    }
  }
</style>
